export default class Enumeration {
  constructor(obj) {
    for (const key in obj) {
      this[key] = obj[key]
    }
    return Object.freeze(this)
  }
  has = (key) => {
    return this.hasOwnProperty(key);
  }
  key = (val) =>{
    let keys = Object.keys(this);
    for(let i=0;i<keys.length;i++){
      if(this[keys[i]]===val)
        return keys[i];
    }
    return "";
  }
  values = () =>{
    let strings = Object.keys(this);
    for(let i=0;i<3;i++) {
     strings.shift();
    }
    return strings;
  }
}
